module.exports = __webpack_public_path__ + "img/Whatsapp.beb1b6e7.svg";